<div class="row">
  <div class="col-md-12 px-3">
    <h3>{{ waybillType }} Request</h3>
  </div>
  <div class="col-md-12">
    <mat-action-list class="d-flex justify-content-end align-items-center">
      <a mat-button aria-label="Use As Template" (click)="useAsTemplate.emit()" *ngIf="!status?.includes('Queued')">Use As Template</a>
      <a mat-button aria-label="Transaction Event History" (click)="openEventHistoryDialog()">Transaction Event History</a>
      <a mat-button aria-label="Original Location Record" (click)="openOriginalLocationDialog()">Original Location Record</a>
      <a mat-button aria-label="Original Waybill" (click)="openWaybillDialog('PREVWB')">Original Waybill</a>
      <a mat-button aria-label="Diversion Waybill" (click)="openWaybillDialog('POSTWB')" *ngIf="!isWaybillType('Origin')">
        <span *ngIf="isWaybillType('Diversion')">Diversion Waybill</span>
        <span *ngIf="isWaybillType('Destination')">Turnover Waybill</span>
      </a>
      <a mat-button aria-label="Diversion Waybill" (click)="openWaybillDialog('MISCWB')">Miscellaneous Waybill</a>
      <a mat-button aria-label="Return To List" (click)="backToList()">Return To List</a>
      <button mat-icon-button class="m-3 mr-4 pr-8" aria-label="Print" matTooltip="Print" (click)="printPreview()">
        <mat-icon fontSet="fas" fontIcon="fa-print"></mat-icon>
      </button>
    </mat-action-list>
  </div>
</div>
